<template>
  <div>
    <v-row>
        <v-col cols="6">
            <v-row>
                <v-col cols="8">
                    <v-text-field
                    type="text"
                    outlined
                    label="Email Tujuan"
                    v-model="emailTujuan"        
                    />             
                </v-col>
                <v-col cols="4">    
                    <v-btn color="success" @click="kirimSeritifikat()">KIRIM SERTIFIKAT</v-btn>
                </v-col>
                <v-col>
                    <v-checkbox
                    v-model="checkEmailMember"
                    :label="`Email Member: ${emailMember}`"
                    @click="chooseEmailMember()"
                    ></v-checkbox>
                    <v-checkbox
                    v-model="checkEmailPerusahaan"
                    :label="`Email Perusahaan: ${emailPerusahaan}`"
                    @click="chooseEmailPerusahaan()"
                    ></v-checkbox>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="8">
                    <v-text-field
                    type="text"
                    outlined
                    label="Sertifikat Vendor"
                    v-model="fileSertifikat"
                    readonly
                    append-icon="get_app"
                    @click:append="getLinkDownload(fileSertifikat)"
                    />  
                </v-col>
                <v-col cols="4">
                    <v-btn color="info" @click="buatSertifikat()">BUAT SERTIFIKAT</v-btn>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="6">
            <br>
            <br>
            <br>
            <br>
            Instruksi :<br>
            1. Jika sertifikat belum dibuat, silahkan klik BUAT SERTIFIKAT <br>
            2. Silahkan pilih checkbox untuk mengisi Email Tujuan, atau ketikan Email Tujuan<br>
            3. Klik KIRIM SERTIFIKAT untuk mengirim sertifikat vendor ke Email Tujuan
        </v-col>
    </v-row>
    
    
    <v-dialog v-model="submitting" persistent max-width="300px">
        <v-card dark>
            <v-card-title>Sedang diproses</v-card-title>
            <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
        </v-card>
    </v-dialog>

    <!-- Notification -->
    <v-snackbar
        v-model="notification.show"
        :color="notification.color"
        :top="true"
        :right="true"
        :timeout=3000
    >
        {{notification.text}}
    </v-snackbar>
  </div>
</template>

<script>
import axios from 'axios'
const apiUrl = process.env.VUE_APP_ROOT_API

export default {
  name: 'Sertifikat Vendor',
  props: [
    'Id'
  ],
  watch: {
    Id: function(newVal, oldVal) {
      console.log(`oldVal = ${oldVal}, newVal = ${newVal}`)
      this.getVendorData(newVal)
    }
  },
  data: function() {
    return {
      fileSertifikat: "",
      emailTujuan: "",
      emailPerusahaan: "",
      emailMember: "",
      checkEmailMember: true,
      checkEmailPerusahaan: false,
      submitting: false,
      notification:
      {
        show: false,
        color: "",
        text: ""
      },
    }
  },
  computed: {
    
  },
  mounted: function() {
    this.checkEmailMember= true
    this.checkEmailPerusahaan= false
    this.getVendorData();
  },
  methods: {
    
    getVendorData: async function() {
      this.remarkSubmitted = false;
      
      await axios.get(`${apiUrl}/vendor/registrasi/perusahaan/${this.Id}`)
      .then((response) => {
        const ven = response.data.data
        this.emailMember = ven.emailMember
        this.emailPerusahaan = ven.email
        this.emailTujuan = this.emailMember
        this.fileSertifikat = ven.fileSertifikat ? ven.fileSertifikat : "Sertifikat Belum Dibuat";
        console.log("response sertifikat: ", ven)
      })
    },

    getLinkDownload: function(dok) {
        /*
      axios.get(`${apiUrl}/sert/${dok}`, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = dok
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
      */
      window.open(`${apiUrl}/sert/${dok}`, '_blank');
    },

    chooseEmailMember: function() {
        this.checkEmailMember = true;
        this.checkEmailPerusahaan = false;
        this.emailTujuan = this.emailMember
    },

    chooseEmailPerusahaan: function() {
        this.checkEmailPerusahaan = true
        this.checkEmailMember = false
        this.emailTujuan = this.emailPerusahaan
    },

    buatSertifikat: async function() {
        this.submitting = true;
        await axios.get(`${apiUrl}/vendor/create-sertifikat/${this.Id}`)
        .then((response) => {
            const ven = response.data.data
            this.emailMember = ven.emailMember
            this.emailPerusahaan = ven.email
            this.emailTujuan = this.emailMember
            this.fileSertifikat = ven.fileSertifikat;
            this.chooseEmailMember();
            this.notification = {
                show: true,
                color: "warning",
                text: "Serifikat Berhasil Dibuat"
            }
        })
        .catch( (err) => {
            this.submitting = false;
            this.notification = {
                show: true,
                color: "error",
                text: "Serifikat Gagal Dibuat "+err
            }
        })
        .finally( () => {
            this.submitting = false;
        });
    },

    kirimSeritifikat: async function() {
        if(this.fileSertifikat == 'Sertifikat Belum Dibuat') {
            this.notification = {
                show: true,
                color: "error",
                text: "File sertifikat vendor belum dibuat, silahkan dibuat terlebih dahulu"
            }
        }else {
            let postData = {emailSend: this.emailTujuan, vendorId: this.Id};
            axios.post(apiUrl+"/vendor/send-sertifikat", postData,{})
            .then((response) => {
                
                this.notification = {
                    show: true,
                    color: "warning",
                    text: response.data.message
                }
            })
            .catch( (err) => {
                this.submitting = false;
                this.notification = {
                    show: true,
                    color: "error",
                    text: "Serifikat Gagal Dikirim ke "+err
                }
            })
            .finally( () => {
                this.submitting = false;
            });
        }
        
    },

  }
}
</script>

<style>

</style>